'use client'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { useMutation } from '@tanstack/react-query'
import services from '../services'
import { Params } from '../services/confirm-email'
import { toast } from '@/shared/ui/use-toast'
import { paths } from '@/shared/routing'
import { useRouter } from '@/shared/config/i18n'

export default function useConfirmEmail() {
  const router = useRouter()
  const mutationKey = [queryKeys((a, m, p) => a.auth.confirmEmail + m.get)]
  const mutations = useMutation({
    mutationKey,
    mutationFn: async (params: Params) => apiResponseHandler(await services.confirmEmail(params)),
    onError: (error) => {
      toast({
        variant: 'destructive',
        title: 'Не удалось подтвердить электронную почту.',
        description: error?.message || 'Произошла ошибка при подтверждении.',
      })
    },
    onSuccess: async (data) => {
      toast({
        variant: 'default',
        title: 'Электронная почта успешно подтверждена.',
        description:
          data?.message || 'Ваш адрес электронной почты был успешно подтвержден. Теперь вы можете авторизоваться.',
      })
      router.push(paths.login)
    },
  })

  return mutations
}
